export default "__VITE_ASSET__BhGE4Mf2__"